export const reviewDetails = [
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_ajay_modi_travels_private_limited_1.mp4",
        agencyName: 'AJAY MODI TRAVELS PRIVATE LIMITED'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_hudels_hospitality_services.mp4",
        agencyName: 'Hudels Hospitality Services'
    },
    // {
    //     videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_dekho_duniya.mp4",
    //     agencyName: 'Dekho Duniya'
    // },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_dj_travel_agency_1.mp4",
        agencyName: 'DJ Travel Agency'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_general_travels.mp4",
        agencyName: 'General Travels'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_global_travels.mp4",
        agencyName: 'Global Travels'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_honeymoon_travels.mp4",
        agencyName: 'Honeymoon Travels'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_krishna_tours_&_travel.mp4",
        agencyName: 'Krishna Tours & Travel'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_lingal_enterprises.mp4",
        agencyName: 'Lingal Enterprises'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_trip_solution.mp4",
        agencyName: 'Trip solution'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_lotsatravel_tours.mp4",
        agencyName: 'LOTSATRAVEL TOURS'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_round_around.mp4",
        agencyName: 'Round Around'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_satnam_travel_services.mp4",
        agencyName: 'Satnam Travel Services'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_shri_ganesh_tours_&_travels.mp4",
        agencyName: 'Shri Ganesh Tours & Travels'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_spectra_royale_holidays.mp4",
        agencyName: 'Spectra Royale Holidays'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_swastik.mp4",
        agencyName: 'Swastik'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_travel_lounge.mp4",
        agencyName: 'Travel Lounge'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_travel_stories.mp4",
        agencyName: 'Travel Stories'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_travelling_divas.mp4",
        agencyName: 'Travelling Divas'
    },
    {
        videoLink: "https://mypartnerimgak.mmtcdn.com/video_testimonial/new_traviz_idea.mp4",
        agencyName: 'TRAVIZ IDEA'
    },
];
  